<template>
	<div
		class="d-flex flex-column d-lg-flex flex-lg-column flex-xl-row justify-content-lg-between px-lg-0 align-items-lg-center position-relative">
		<div class="col-12 col-xl-6 px-0">
			<div class="d-flex flex-column flex-lg-row nowrap text-grey-900"
				v-if="specialStay && !hasMultipleVariantsWithDifferentSkipass">
				<span v-if="!isDisplayPlaceholders && store.state.packCode !== 'HS'" class="me-4 text-nowrap caption">
					<div class="caption-strong text-grey-900 mt-1">
						{{ store.state.content.planner_shortStay_rate }}
						<!-- Custom logic for en_US locale and TRAIN package -->
						<span
							v-if="store.getters.locale === 'en_US' && props.variant.codePackage && trainPackCode.includes(props.variant.codePackage)">
							<!-- Calculate nights: skipass+1, max 7, show remainder if >7 -->
							<template v-if="Number(props.variant.skipass) + 1 > 7">
								{{ 7 }}<span v-if="Number(props.variant.skipass) + 1 - 7 > 0">+{{
									Number(props.variant.skipass) + 1 - 7 }}</span> {{
										store.state.content.planner_nights }}
							</template>
							<template v-else>
								{{ Number(props.variant.skipass) + 1 }} {{ store.state.content.planner_nights }}
							</template>
						</span>
						<span v-else>
							<span v-if="props.variant.skipass">
								{{ props.variant.skipass }}
							</span>
							{{ store.state.content.days }}
						</span>
					</div>
					<span class="me-1">{{
						store.state.content.planner_prestationsInclude
					}}</span>
					<svg class="icon info-icon tf-icon-10 tf-icon-sm-20">
						<use xlink:href="#___icon___info"></use>
					</svg>
					:
					<template v-if="packageContent && packageContent[0]">
						<PackageDetalisPopUp>
							<span v-for="(content, content_i) in packageContent" :key="`${content[0]}-${content_i}}`">{{
								content }}</span>
						</PackageDetalisPopUp>
					</template>
				</span>

				<div class="d-flex flex-column flex-lg-row align-items-start">
					<Inclus :isDisplayPlaceholders="isDisplayPlaceholders" :variant="variant"
						class="mb-3 mb-lg-0 me-lg-4" />
					<PaymentCondition v-if="specialStay && variant?.paymentCondition !== undefined"
						:paymentCondition="variant.paymentCondition" :cancellation-date="variant.cancelationUntil"
						:displayTitle="true" :prestId="prestId" :isDisplayPlaceholders="isDisplayPlaceholders"
						class="d-flex align-items-center w-100 h-100" />
				</div>
			</div>
			<PaymentCondition v-if="!specialStay && variant?.paymentCondition !== undefined"
				:paymentCondition="variant.paymentCondition" :cancellation-date="variant.cancelationUntil"
				:displayTitle="true" :prestId="prestId" :isDisplayPlaceholders="isDisplayPlaceholders" />
		</div>
		<div class="col-12 col-xl-6 px-0 d-flex flex-lg-row nowrap justify-content-end align-items-end">
			<div
				class="d-flex flex-column d-lg-flex flex-lg-row justify-content-center align-items-center w-100 px-0 px-lg-2">
				<div class="col-12 col-lg-7 px-0 pe-lg-1">
					<!-- <Prices :isLoading="pricesLoadingSet.has(currentCacheKey)"
						:isDisplayPlaceholders="isDisplayPlaceholders" :packCode="variant && variant.codePackage"
						:crossedPrice="crossedPrice" :totalPrice="totalPrice" :perPrice="perPrice" :maxPromo="maxPromo"
						:locale="store.getters.locale" /> -->
					<component
						:is="checkIfUkWebsite ? PricesPP : Prices"
						:isLoading="pricesLoadingSet.has(currentCacheKey)"
						:isDisplayPlaceholders="isDisplayPlaceholders" :packCode="variant && variant.codePackage"
						:crossedPrice="crossedPrice" :totalPrice="totalPrice" :perPrice="perPrice" :maxPromo="maxPromo"
						:locale="store.getters.locale" 
						:totalParticipants="store.state.participants.length"
					></component>
				</div>
				<span class="d-none d-lg-inline-block position-relative pe-lg-3">
					<svg v-if="!isDisabledPrest && !checkIfUkWebsite" class="info-icon icon tf-icon-10 tf-icon-sm-20">
						<use xlink:href="#___icon___info"></use>
					</svg>
					<PackageDetalisPopUp :top="'0'" :left="'10px'">
						{{ store.state.content.planner_prestationsPriceInfo }}
					</PackageDetalisPopUp>
				</span>
				<div
					class="col-12 col-sm-6 col-lg-6 col-lg-5 px-0 d-flex align-items-center justify-content-center accommodation-btn">

					<SelectButton :accommodationOnly="accommodationOnly" 
						:isDisplayPlaceholders="isDisplayPlaceholders" :locale="store.getters.locale"
						:variant="variant" :selectedQuantity="selectedQuantity" :select_location="'prestation'"
						:disabled="isDisabledPrest" 
						@selectClick="(id: string) => emit('select', id)"
						@clear="(id: string) => emit('clear', id)"
						@dropdownClick="(payload: any) => emit('dropdownClick', payload)"
						@dropdownSelect="(payload: { newSelected: number; id: string }) => emit('dropdownSelect', payload)" />
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {	
	computed,
	ComputedRef,
	watch
} from "vue";

// Store
import { useStore } from "vuex"

const store = useStore();
//import store from "@/vue/planning/store/store";

import packageDetailsContentMap from "@/config/packageDetailsContentMap"

// Config
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import { airportCodeMap } from "@/config/airportCodeMap"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"

// State
import responsesCache from "@/vue/planning/state/responsesCache";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";

// Components
import Prices from "@/vue/planning/components/common/prices.vue";
import PricesPP from "@/vue/planning/components/common/pricesPP.vue";
import SelectButton from "@/vue/planning/components/result/selectBtn.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue";
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"

// Computed
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";

// Logic
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
	getMaxPromo,
} from "@/logic/pricesAndDiscount";

import displayPrice from "@/displayPrice/displayPrice"

interface Props {
	variant: any;
	isDisplayPlaceholders: boolean;
}
interface Emits {
	(e: "select", id: string): void;
	(e: "clear", id: string): void;
	(
		e: "dropdownSelect",
		selectedData: { newSelected: number; id: string }
	): void;
	(e: "dropdownClick", obj: any): void;
}

const props = withDefaults(defineProps<Props>(), {
	isDisplayPlaceholders: false,
});
const emit = defineEmits<Emits>();

const checkIfUkWebsite = computed(() => {
	return false; // Wait for green light
	//return getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com";
});

// Helper function to get origin the same way getWiypPrice does
const getOriginForLookup = (packCode: string): string => {
	const rawOrigin = store.state.flightOrigin ?? store.state.wiypDefaultFlightOrigin ?? "";

	if (!packCode) return 'NA';

	if (flightPackCode.includes(packCode)) {
		return airportCodeMap.has(rawOrigin) ? rawOrigin : Array.from(airportCodeMap.keys())[0] || 'NA';
	} else if (trainPackCode.includes(packCode)) {
		return trainStationCodeMap.has(rawOrigin) ? rawOrigin : Array.from(trainStationCodeMap.keys())[0] || 'NA';
	}
	return 'NA';
};

// Create a computed property to track the specific wiypCall data for this variant
// This ensures reactivity when wiypCall changes
const wiypCallData = computed(() => {
	const origin = getOriginForLookup(store.state.packCode);
	const familyComposition = store.state.participants.join('-');
	const packageCode = store.state.packCode;
	const packageId = props?.variant?.prestId;
	if (!packageId) return undefined;	
	return store.getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(
		familyComposition,
		origin,
		packageCode,
		packageId
	);
});

// computed
const accommodationOnly: ComputedRef<string | undefined> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const accommodation = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(accommodation && accommodation.accomPriceWiyp) {
			return accommodation.accomPriceWiyp;
		}
	}

	if (store.state.packCode != 'HS' && store.state.selectedPrestIds && Object.keys(store.state.selectedPrestIds).length > 0) {
		try {
			const price = store.state.prestMaps.prices[store.state.packCode][props.variant.id].priceAccommodationOnly;
			if (price) {
				return displayPrice(parseInt(price) * 100, store.getters.locale) ?? undefined;
			}
		}
		catch (e) {
			console.error(e);
		}
	}
	return undefined;
});

const selectedQuantity: ComputedRef<number> = computed(() => {
	return props.variant && store.state.selectedPrestIds[props.variant.id];
});

const crossedPrice: ComputedRef<number> = computed(() => {
	if (!props.variant) return NaN;
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const crossed = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(crossed && crossed.publicPriceWiyp) {
			return crossed.publicPriceWiyp;
		}
	}
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
});

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
});

const totalPrice: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const total = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(total && total.sellingPriceWiyp) {
			return total.sellingPriceWiyp;
		}
	}
	return props.variant && getPrestTotalPrice(props.variant);
});

const isDisabledPrest: ComputedRef<boolean> = computed(() => {
	return totalPrice.value <= 0;
});

const maxPromo: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const promoPrice = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(promoPrice && promoPrice.publicPriceWiyp && promoPrice.sellingPriceWiyp) {
			return getMaxPromo(Math.round(( promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) / promoPrice.publicPriceWiyp * 100));
		}
	}
	return props.variant && getPrestMaxPromo(props.variant);
});

const prestId: ComputedRef<string> = computed(() => {
	return props.variant.prestIdSource
})

const specialStay: ComputedRef<boolean> = computed(() => {
	// Show special stay UI for any variant with skipass
	return props.variant && props.variant.skipass;
});

const hasMultipleVariantsWithDifferentSkipass: ComputedRef<boolean> = computed(() => {
	// Get all variants from the store or parent component
	const allVariants = store.state.prestationsFromCatalog?.flatMap((p: any) => p.variants || []) || [];
	const skipassValues = new Set(allVariants.map((v: any) => v.skipass).filter(Boolean));
	return skipassValues.size > 1;
});

const packageContent = computed(() => {
	const defaultContent = store.getters.packageInfoContent || [];
	if (store.getters.locale === 'en_US' && props.variant.codePackage && trainPackCode.includes(props.variant.codePackage)) {
		const contentVariabels = packageDetailsContentMap.get(props.variant.codePackage)

		if (!contentVariabels) {
			console.error(`no content variables for ${props.variant.codePackage}`);
			return;
		}

		return contentVariabels.map(content => store.state.content[content]) || defaultContent
	}

	return defaultContent
});

// Watch wiypCall changes to ensure computed properties recompute
// Watching both the store state and the computed property ensures reactivity
watch(
	[
		() => store.state.wiypCall,
		() => store.state.participants,
		() => store.state.flightOrigin,
		() => store.state.packCode,
		() => store.state.dates,
		() => props.variant,
	],
	() => {
		// Force recomputation by accessing the computed property
		wiypCallData.value;
	},
	{ deep: true }
);

</script>

<style scoped>
/* Handles packageDetailsPoup showing */
.info-icon:hover+.package-info-container {
	visibility: visible;
}

@media (max-width: 1400px) {
	.accommodation-btn {
		min-width: 16vw
	}

	.accommodation-btn button {
		margin-right: .20rem !important
	}
}
</style>
